import React , { Suspense }from 'react';

import { ToastContainer, Bounce } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from 'components/App';
import './i18n';

import Accountdefinitions from 'components/Accountdefinitions';
import Article from 'components/Article';
import Register from 'components/Register';
import RequireAuth from 'components/RequireAuth';
import ChangePass from 'components/Changepassword';
import RegisterConfirmation from 'components/Registerconfirmation';
import Login from 'components/Login';
import Articles from 'components/Articles';
import Calendar from 'components/Calendar';
import Games from 'components/Games';
import GameDelete from 'components/GameDelete';
import Events from 'components/Events';
import EventDelete from 'components/EventDelete';
import GameCall from 'components/GameCall';
import GameResults from 'components/GameResults';
import NewStaff from 'components/NewStaff';
import PlayerDelete from 'components/PlayerDelete';
import NewGame from 'components/NewGame';
import Faq from 'components/Faq';
import Home from 'components/Home';
import NewPlayer from 'components/NewPlayer';
import Teams from 'components/Teams';
import NewTeam from 'components/NewTeam';
import TeamDetail from 'components/TeamDetail';
import Notfound from 'components/Notfound';
import Reportproblem from 'components/Reportproblem';
import Offerslist from 'components/OffersList';
import TeamDelete from 'components/TeamDelete';
import Offers from 'components/Offers';
import MyOffers from 'components/MyOffers';
import OffersApplyList from 'components/OffersApplyList';
import Caselist from 'components/Caselist';
import AccountProfile from 'components/Accountprofile';
import Case from 'components/Case';
import Success from 'components/warnings/Success';

global._ = require('lodash');

const Loader = () => (
  <div className="App">
    <div>loading...</div>
  </div>
);

const refresh = () => {
  window.location.href = '/';
}

ReactDOM.render(
  <React.StrictMode>
    <ToastContainer
      position={"bottom-right"}
      autoClose={4000}
      closeOnClick={true}
      pauseOnHover={true}
      draggable={true}
      transition={Bounce}
      theme="light"
    />
    <BrowserRouter>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<App />}>
          {/* Non-AUTH Routes */}
          <Route index element={<RequireAuth refresh={refresh}><Home /></RequireAuth>} />
          <Route path="registar" element={<Register />} />
          <Route path="confirmacao-registo" element={<RegisterConfirmation />} />
          <Route path="alterar-password" element={<ChangePass />} />
          <Route path="login" element={<Login refresh={refresh} />} />
          {/* END Non-AUTH Routes */}

          {/* AUTH Routes  */}
          <Route path="inicio" element={<RequireAuth refresh={refresh}><Home /></RequireAuth>} />
          <Route path="calendario" element={<RequireAuth refresh={refresh}><Calendar /></RequireAuth>} />

          {/* JOGOS Routes */}
          <Route path="jogos" element={<RequireAuth refresh={refresh}><Games /></RequireAuth>} />
          <Route path="jogos/:gameId" element={<RequireAuth refresh={refresh}><NewGame /></RequireAuth>} />
          <Route path="jogos/:gameId/apagar" element={<RequireAuth refresh={refresh}><GameDelete /></RequireAuth>} />
          <Route path="jogos/:gameId/convocatoria" element={<RequireAuth refresh={refresh}><GameCall /></RequireAuth>} />
          <Route path="jogos/:gameId/resultados" element={<RequireAuth refresh={refresh}><GameResults /></RequireAuth>} />
          <Route path="ofertas" element={<RequireAuth refresh={refresh}><Offerslist /></RequireAuth>} />
          <Route path="minhas-ofertas" element={<RequireAuth refresh={refresh}><MyOffers /></RequireAuth>} />
          <Route path="ofertas/nova-oferta" element={<RequireAuth refresh={refresh}><Offers /></RequireAuth>} />
          <Route path="ofertas/:offerId" element={<RequireAuth refresh={refresh}><Offers /></RequireAuth>} />
          <Route path="ofertas/:offerId/candidatar" element={<RequireAuth refresh={refresh}><Offers /></RequireAuth>} />
          <Route path="ofertas/:offerId/candidaturas" element={<RequireAuth refresh={refresh}><OffersApplyList /></RequireAuth>} />
          <Route path="ofertas/:offerId/candidaturas/:candidateId" element={<RequireAuth refresh={refresh}><Offers /></RequireAuth>} />
          {/* END JOGOS Routes */}

          <Route path="eventos" element={<RequireAuth refresh={refresh}><Events /></RequireAuth>} />
          <Route path="eventos/:eventId" element={<RequireAuth refresh={refresh}><Events /></RequireAuth>} />
          <Route path="eventos/:eventId/apagar" element={<RequireAuth refresh={refresh}><EventDelete /></RequireAuth>} />
          <Route path="jogadores/:playerId" element={<RequireAuth refresh={refresh}><NewPlayer /></RequireAuth>} />
          <Route path="staff/:staffId" element={<RequireAuth refresh={refresh}><NewStaff /></RequireAuth>} />

          <Route path="nova-equipa" element={<RequireAuth refresh={refresh}><NewTeam /></RequireAuth>} />
          <Route path="equipas" element={<RequireAuth refresh={refresh}><Teams /></RequireAuth>} />
          <Route path="equipa/:equipaId/novo-jogo" element={<RequireAuth refresh={refresh}><NewGame /></RequireAuth>} />
          <Route path="equipa/:equipaId/apagar" element={<RequireAuth refresh={refresh}><TeamDelete /></RequireAuth>} />
          <Route path="equipas/:teamId" element={<RequireAuth refresh={refresh}><TeamDetail /></RequireAuth>} />
          <Route path="equipas/:teamId/novo-jogador" element={<RequireAuth refresh={refresh}><NewPlayer /></RequireAuth>} />
          <Route path="equipas/:teamId/novo-staff" element={<RequireAuth refresh={refresh}><NewStaff /></RequireAuth>} />
          <Route path="equipa/:teamId/jogadores/:playerId/apagar" element={<RequireAuth refresh={refresh}><PlayerDelete /></RequireAuth>} />

          <Route path="artigos" element={<RequireAuth refresh={refresh}><Articles /></RequireAuth>} />
          <Route path="artigos/:articleId" element={<RequireAuth refresh={refresh}><Article /></RequireAuth>} />
          <Route path="faq/:articleId" element={<RequireAuth refresh={refresh}><Faq /></RequireAuth>} />
          <Route path="conta/:accId" element={<RequireAuth refresh={refresh}><AccountProfile /></RequireAuth>} />
          
          <Route path="definicoes-conta" element={<RequireAuth refresh={refresh}><Accountdefinitions /></RequireAuth>} />
          <Route path="lista-casos" element={<RequireAuth refresh={refresh}><Caselist /></RequireAuth>} />
          <Route path="casos/:caseId" element={<RequireAuth refresh={refresh}><Case /></RequireAuth>} />
          <Route path="reportar-problema" element={<RequireAuth refresh={refresh}><Reportproblem /></RequireAuth>} />
          <Route path="sucesso" element={<RequireAuth refresh={refresh}><Success message={'Este componente pode ser utilizado para uma fantastica mensagem de successo, utiliza para isso'} /></RequireAuth>} />
          <Route path="*" element={<RequireAuth refresh={refresh}><Notfound /></RequireAuth>} />
          {/* END AUTH Routes */}
        </Route>
      </Routes>
    </Suspense>


    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
